import { render, staticRenderFns } from "./TheIdentifier.vue?vue&type=template&id=fe500b88&scoped=true"
import script from "./TheIdentifier.vue?vue&type=script&lang=js"
export * from "./TheIdentifier.vue?vue&type=script&lang=js"
import style0 from "./TheIdentifier.vue?vue&type=style&index=0&id=fe500b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe500b88",
  null
  
)

export default component.exports